import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-grid-cards-without-frame',
  templateUrl: './grid-cards-without-frame.component.html',
  styleUrls: ['./grid-cards-without-frame.component.css'],
})
export class GridCardsWithoutFrameComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  ngOnInit(): void {
    console.log(this.data);
  }
  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }

  extractTitle(title: string, part: number): string {
    const words = title.split(' ');
    if (part === 1) {
      return words.slice(0, words.length / 2).join(' ');
    } else if (part === 2) {
      return words.slice(words.length / 2).join(' ');
    }
    return title;
  }
}
